/**
 * Icons for {@link PresentationBuilderComponent}. Register once via
 * `importProvidersFrom(LucideAngularModule.pick(PRESENTATION_BUILDER_LUCIDE_ICONS))` in app bootstrap
 * (main Polarix app and lumi-slides shell). Standalone components import bare `LucideAngularModule`.
 */
import {
  AlertCircle,
  AlignCenter,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalDistributeCenter,
  AlignLeft,
  AlignRight,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalDistributeCenter,
  AppWindow,
  ArrowRight,
  BarChart3,
  BetweenVerticalStart,
  Bold,
  BringToFront,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleSmall,
  Check,
  ClipboardPaste,
  Clock,
  Copy,
  CopyPlus,
  CaseLower,
  CaseUpper,
  Crosshair,
  Download,
  Droplet,
  FileText,
  FileUp,
  Film,
  FlipHorizontal,
  FlipVertical,
  Focus,
  Folder,
  Frame,
  Group,
  GripHorizontal,
  Hash,
  Home,
  Image,
  ImagePlus,
  Italic,
  Layout,
  LayoutGrid,
  LayoutList,
  LayoutTemplate,
  Layers,
  Link,
  List,
  ListIndentIncrease,
  ListOrdered,
  ListX,
  Lock,
  Maximize2,
  Menu,
  MessageSquare,
  Minus,
  MoveDown,
  MoveUp,
  MoreHorizontal,
  MoreVertical,
  MousePointer2,
  Omega,
  Palette,
  Paintbrush,
  PanelLeft,
  PanelLeftClose,
  Pencil,
  Play,
  Plus,
  Presentation,
  Redo2,
  RemoveFormatting,
  RotateCcw,
  RotateCw,
  Ruler,
  Save,
  Scissors,
  SendToBack,
  Share2,
  Shapes,
  SlidersHorizontal,
  Sparkles,
  Square,
  SquareDashed,
  Star,
  SwatchBook,
  Table,
  Trash2,
  TextSelect,
  Type,
  Ungroup,
  Undo2,
  Underline,
  Upload,
  Video,
  Volume2,
  Workflow,
  X,
  ZoomIn,
  ZoomOut,
} from 'lucide-angular/src/icons';

export const PRESENTATION_BUILDER_LUCIDE_ICONS = {
  AlertCircle,
  AlignCenter,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalDistributeCenter,
  AlignLeft,
  AlignRight,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalDistributeCenter,
  AppWindow,
  ArrowRight,
  BarChart3,
  BetweenVerticalStart,
  Bold,
  BringToFront,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleSmall,
  Check,
  ClipboardPaste,
  Clock,
  Copy,
  CopyPlus,
  CaseLower,
  CaseUpper,
  Crosshair,
  Download,
  Droplet,
  FileText,
  FileUp,
  Film,
  FlipHorizontal,
  FlipVertical,
  Focus,
  Folder,
  Frame,
  Group,
  GripHorizontal,
  Hash,
  Home,
  Image,
  ImagePlus,
  Italic,
  Layout,
  LayoutGrid,
  LayoutList,
  LayoutTemplate,
  Layers,
  Link,
  List,
  ListIndentIncrease,
  ListOrdered,
  ListX,
  Lock,
  Maximize2,
  Menu,
  MessageSquare,
  Minus,
  MoveDown,
  MoveUp,
  MoreHorizontal,
  MoreVertical,
  MousePointer2,
  Omega,
  Palette,
  Paintbrush,
  PanelLeft,
  PanelLeftClose,
  Pencil,
  Play,
  Plus,
  Presentation,
  Redo2,
  RemoveFormatting,
  RotateCcw,
  RotateCw,
  Ruler,
  Save,
  Scissors,
  SendToBack,
  Share2,
  Shapes,
  SlidersHorizontal,
  Sparkles,
  Square,
  SquareDashed,
  Star,
  SwatchBook,
  Table,
  Trash2,
  TextSelect,
  Type,
  Ungroup,
  Undo2,
  Underline,
  Upload,
  Video,
  Volume2,
  Workflow,
  X,
  ZoomIn,
  ZoomOut,
};
